export const userMessageStyles = {
  root: "flex justify-end",
  bubble:
    "max-w-[78%] rounded-2xl rounded-br bg-user-bubble px-3.5 py-2.5 text-sm leading-relaxed text-foreground",
};
